import React, { useState } from 'react'

// Components
import GlobalStyles from '../../../../components/component-items/styles'
import { TableCell } from '../../../../components/component-items/datatable'
import { PermissionGate } from '../../../../components/rbac'
import { TableRow, SummaryLine } from '../styles'

// Modals (lazy loaded)
const RemoveItemModal = React.lazy(() => import('../modals/remove-item-modal'))

// Types
import type { InventoryItem } from '../types'

type ContentsTabProps = {
  lpn: string
  contents: InventoryItem[]
  totalQuantity: number
  contentsCount: number
}

export const ContentsTab = ({ lpn, contents, totalQuantity, contentsCount }: ContentsTabProps) => {
  const [removeItem, setRemoveItem] = useState<InventoryItem | null>(null)

  return (
    <div>
      <SummaryLine>
        {contentsCount} SKU{contentsCount !== 1 ? 's' : ''}, {totalQuantity} units
      </SummaryLine>
      {contents.length > 0 ? (
        <GlobalStyles.DataTable>
          <thead>
            <tr>
              <th>
                <span className="text">SKU</span>
              </th>
              <th>
                <span className="text">Barcode</span>
              </th>
              <th>
                <span className="text center">Lot</span>
              </th>
              <th>
                <span className="text center">On Hand</span>
              </th>
              <th>
                <span className="text center">Reserved</span>
              </th>
              <PermissionGate segment="inventory" minLevel="operator">
                <th>
                  <span className="text center">Action</span>
                </th>
              </PermissionGate>
            </tr>
          </thead>
          <tbody>
            {contents.map((item: InventoryItem) => (
              <TableRow key={item.id}>
                <TableCell input={item.variant_sku} />
                <TableCell input={item.variant_barcode || '\u2014'} />
                <TableCell center input={item.lot_number || '\u2014'} />
                <TableCell center input={item.on_hand} />
                <TableCell center input={item.reserved} />
                <PermissionGate segment="inventory" minLevel="operator">
                  <TableCell center>
                    <GlobalStyles.Button
                      className="secondary"
                      style={{ fontSize: '0.8rem', padding: '0.25rem 0.75rem' }}
                      onClick={() => setRemoveItem(item)}
                    >
                      Remove
                    </GlobalStyles.Button>
                  </TableCell>
                </PermissionGate>
              </TableRow>
            ))}
          </tbody>
        </GlobalStyles.DataTable>
      ) : (
        <p style={{ color: '#74788d', fontStyle: 'italic' }}>No inventory items in this container.</p>
      )}

      {removeItem && (
        <React.Suspense fallback={null}>
          <RemoveItemModal lpn={lpn} item={removeItem} show={!!removeItem} onHide={() => setRemoveItem(null)} />
        </React.Suspense>
      )}
    </div>
  )
}

export default ContentsTab
